












































































import { CrudService } from '@/data/services/crud.service';
import { Component, Vue, Inject, Ref, Prop } from 'vue-property-decorator';
import { Actor } from '@/data/models/actor.model';
import NoteFilter from './NoteFilter.vue';
import NoteList from './NoteList.vue';
import store, { State } from '@/store';
import { Search } from '@/data/models/search.model';
import { cloneDeep } from 'lodash';
import { Note } from '@/data/models/note.model';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

@Component({
	components: {
		NoteFilter,
		NoteList,
		ValidationObserver,
		ValidationProvider
	},
})
export default class NoteComponent extends Vue {
    @Prop() actorid!: number;
	@Prop() entity!: string;
	@Prop({ default: true }) checkFilter?: boolean;

	@Inject('CrudService') crudService!: CrudService<Note>;

	@Ref('list') list!: NoteList;
    @Ref('filter') filter!: NoteFilter;
    
	editingNote: Note;
	isModalOpen = false;
	state!: State;

	constructor() {
		super();
		this.state = store;
		this.editingNote = new Note();
	}

	onSearch(event: Search) {
		this.list.advancedSearch = event;
		this.list.loadNote();
	}
    
	openNoteModal(note: Note) {
		if(!note) {
			note = new Note();
			note.actorid = this.actorid;
			note.entity = this.entity;
			this.editingNote = note;
		} else {
			this.editingNote = cloneDeep(note);
		}
		this.isModalOpen = true;
	}

	closeModal() {
		this.isModalOpen = false;
	}

	saveNote() {
		const call = (this.editingNote!.id) ? 
			this.crudService.saveEntity(Note, 'note', this.editingNote) : 
			this.crudService.createEntity(Note, 'note', this.editingNote);
		call.then(() => {
			this.closeModal();
			this.list.loadNote();
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		});
	}

	deleteNote(item: Actor) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-person-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Note, 'note', item)
					.then(() => {
						this.list.loadNote();
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

	befoureMount() {
		this.list.loadNote();
	}
}
